// extracted by mini-css-extract-plugin
var _1 = "UKPriceTable_container__TjW2K";
var _2 = "UKPriceTable_numberColumn__YwGXm";
var _3 = "UKPriceTable_row__heVN0";
var _4 = "UKPriceTable_table__I6RAz";
var _5 = "UKPriceTable_textColumn__G6dU6";
export { _1 as "container", _2 as "numberColumn", _3 as "row", _4 as "table", _5 as "textColumn" }
